import { jsx as E } from "react/jsx-runtime";
import g from "react";
import { styled as W } from "@mui/material/styles";
import q from "@mui/material/TextField";
import z from "@mui/material/Box";
const G = W(q)`
  input {
    text-align: center;
  }
`, J = {
  TextFieldStyled: G
}, Q = (n) => /* @__PURE__ */ E(J.TextFieldStyled, { ...n }), B = {
  left: "ArrowLeft",
  right: "ArrowRight",
  backspace: "Backspace",
  home: "Home",
  end: "End"
};
function U(n, l) {
  return n <= 0 ? [] : Array.from({ length: n }, l);
}
function X(n, l, f) {
  return n.map((u, x) => l === x ? f : u);
}
function P(n) {
  return n.join("");
}
function M(n, l) {
  return [...n, l];
}
function Z(n, l, f) {
  return n.reduce(
    (u, x, C) => {
      const { characters: y, restArrayMerged: d } = u;
      if (C < f)
        return {
          restArrayMerged: d,
          characters: M(y, x)
        };
      const [D, ...V] = d;
      return {
        restArrayMerged: V,
        characters: M(y, D || "")
      };
    },
    {
      restArrayMerged: l,
      characters: []
    }
  ).characters;
}
function v(n) {
  return n.split("");
}
function N(n) {
  const l = g.useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return g.useInsertionEffect(() => {
    l.current = n;
  }), g.useCallback((...f) => l.current?.(...f), []);
}
const ee = () => !0, oe = g.forwardRef(
  (n, l) => {
    const {
      value: f = "",
      length: u = 4,
      autoFocus: x = !1,
      onChange: C,
      TextFieldsProps: y,
      onComplete: d,
      validateChar: D = ee,
      className: V,
      onBlur: b,
      ...K
    } = n, j = g.useRef(f), k = N(d), I = N((e) => {
      const t = e.slice(0, u);
      return {
        isCompleted: t.length === u,
        finalValue: t
      };
    });
    g.useEffect(() => {
      const { isCompleted: e, finalValue: t } = I(
        j.current
      );
      e && k(t);
    }, [u, k, I]);
    const p = U(
      u,
      (e, t) => ({
        character: f[t] || "",
        inputRef: g.createRef()
      })
    ), A = (e) => p.findIndex(({ inputRef: t }) => t.current === e), T = () => p.map(({ character: e }) => e), O = (e, t) => {
      const a = X(
        T(),
        e,
        t
      );
      return P(a);
    }, $ = (e) => {
      p[e]?.inputRef.current?.focus();
    }, c = (e) => {
      p[e]?.inputRef.current?.select();
    }, R = (e) => {
      e + 1 !== u && (p[e + 1].character ? c(e + 1) : $(e + 1));
    }, S = (e, t) => typeof D != "function" ? !0 : D(e, t), Y = (e) => {
      const t = A(e.target);
      if (t === 0 && e.target.value.length > 1) {
        const { finalValue: m, isCompleted: F } = I(
          e.target.value
        );
        C?.(m), F && d?.(m), c(m.length - 1);
        return;
      }
      const a = e.target.value[0] || "";
      let o = a;
      o && !S(o, t) && (o = "");
      const s = O(t, o);
      C?.(s);
      const { isCompleted: h, finalValue: i } = I(s);
      h && d?.(i), o !== "" ? s.length - 1 < t ? c(s.length) : R(t) : a === "" && s.length <= t && c(t - 1);
    }, _ = (e) => {
      const t = e.target, a = t.selectionStart, o = t.selectionEnd, s = A(t), h = a === 0 && o === 0;
      if (t.value === e.key)
        e.preventDefault(), R(s);
      else if (B.backspace === e.key) {
        if (!t.value)
          e.preventDefault(), c(s - 1);
        else if (h) {
          e.preventDefault();
          const i = O(s, "");
          C?.(i), i.length <= s && c(s - 1);
        }
      } else B.left === e.key ? (e.preventDefault(), c(s - 1)) : B.right === e.key ? (e.preventDefault(), c(s + 1)) : B.home === e.key ? (e.preventDefault(), c(0)) : B.end === e.key && (e.preventDefault(), c(p.length - 1));
    }, H = (e) => {
      const t = e.clipboardData.getData("text/plain"), a = e.target, o = p.findIndex(
        ({ character: r, inputRef: w }) => r === "" || w.current === a
      ), s = T(), h = Z(
        s,
        v(t),
        o
      ).map((r, w) => S(r, w) ? r : ""), i = P(h);
      C?.(i);
      const { isCompleted: m, finalValue: F } = I(i);
      m ? (d?.(F), c(u - 1)) : c(i.length);
    }, L = (e) => {
      if (!p.some(({ inputRef: a }) => a.current === e.relatedTarget)) {
        const { isCompleted: a, finalValue: o } = I(f);
        b?.(o, a);
      }
    };
    return /* @__PURE__ */ E(
      z,
      {
        display: "flex",
        gap: "20px",
        alignItems: "center",
        ref: l,
        className: `MuiOtpInput-Box ${V || ""}`,
        ...K,
        children: p.map(({ character: e, inputRef: t }, a) => {
          const {
            onPaste: o,
            onFocus: s,
            onKeyDown: h,
            className: i,
            onBlur: m,
            ...F
          } = typeof y == "function" ? y(a) || {} : y || {};
          return /* @__PURE__ */ E(
            Q,
            {
              autoFocus: x ? a === 0 : !1,
              autoComplete: "one-time-code",
              value: e,
              inputRef: t,
              className: `MuiOtpInput-TextField MuiOtpInput-TextField-${a + 1} ${i || ""}`,
              onPaste: (r) => {
                r.preventDefault(), H(r), o?.(r);
              },
              onFocus: (r) => {
                r.preventDefault(), r.target.select(), s?.(r);
              },
              onChange: Y,
              onKeyDown: (r) => {
                _(r), h?.(r);
              },
              onBlur: (r) => {
                m?.(r), L(r);
              },
              ...F
            },
            a
          );
        })
      }
    );
  }
);
export {
  oe as MuiOtpInput
};
